module.exports = __webpack_public_path__ + "static/media/cardBackgroundHelexia.4bbba0b6.svg";